export default function({ req, redirect }) {
    if (process.server) {
        if (!req.headers.referer) {
            redirect('/not-found');
        }
    }
}
